import ajaxRequest from './ajaxRequest';
import initMiniFavourites from '../pages/global/header/miniFavourites';
import { API, MiniFavouritesData, MiniEntry } from '../types';

export function addToFavourites(productCode: string): Promise<MiniFavouritesData & { entry: MiniEntry }> {
  return ajaxRequest({ method: 'POST', url: API.FAVOURITES_ADD, data: { productCode } }).then(
    ({ entry, entries, miniFavouritesDisplayLimit, successful, errorMessage }) => {
      if (successful) {
        return {
          entry,
          entries,
          miniFavouritesDisplayLimit
        };
      }
      throw Error(errorMessage);
    }
  );
}

export function removeFromFavourites(productCode: string): Promise<MiniFavouritesData> {
  return ajaxRequest({ method: 'POST', url: API.FAVOURITES_REMOVE, data: { productCode } });
}

export function favouritesButtonHandler(): void {
  const ADDED_TO_FAVOURITES_CLASS = 'active';
  const SCALEFILL = 'scalefill';

  const { updateMiniFavouritesGlobalState, updateMiniFavouritesMarkup, updateMiniFavouritesPopupMarkup } =
    initMiniFavourites();
  document.addEventListener('click', (e: Event) => {
    const favouritesButtonElement = (e.target as Element).closest('[data-button-type="favourites"]');
    const productCode = favouritesButtonElement
      ? (favouritesButtonElement as HTMLButtonElement).dataset.productCode
      : null;
    if (
      productCode &&
      favouritesButtonElement &&
      window.bbGlobal.miniFavouritesData.isInitialDataFetched &&
      window.bbGlobal.miniFavouritesData.isDataFetching === false
    ) {
      const addingToFavourites = favouritesButtonElement.classList.contains(ADDED_TO_FAVOURITES_CLASS) === false;
      const favouritesProcess = addingToFavourites ? addToFavourites : removeFromFavourites;
      window.bbGlobal.miniFavouritesData.isDataFetching = true;
      favouritesProcess(productCode)
        .then(({ entry, entries, miniFavouritesDisplayLimit }: MiniFavouritesData & { entry?: MiniEntry }) => {
          updateMiniFavouritesGlobalState({ entries, miniFavouritesDisplayLimit });
          updateMiniFavouritesMarkup({ entries, miniFavouritesDisplayLimit });
          if (addingToFavourites) {
            updateMiniFavouritesPopupMarkup({ entry });
            favouritesButtonElement.classList.add(ADDED_TO_FAVOURITES_CLASS);
          } else {
            favouritesButtonElement.classList.remove(ADDED_TO_FAVOURITES_CLASS);
          }
          favouritesButtonElement.classList.add(
            SCALEFILL
          ); /* animation is added once - at first click to avoid animation on page load. Then it animates on switch from display: none */
        })
        .catch((error) => {
          updateMiniFavouritesPopupMarkup({ isError: true, errorMessage: error?.message || '' });
        })
        .finally(() => {
          window.bbGlobal.miniFavouritesData.isDataFetching = false;
        });
    }
  });
}
